import { render, staticRenderFns } from "./industry-reports.vue?vue&type=template&id=0256da7a&"
import script from "./industry-reports.vue?vue&type=script&lang=js&"
export * from "./industry-reports.vue?vue&type=script&lang=js&"
import style0 from "./industry-reports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loader: require('/home/circleci/repo/components/Loader.vue').default})
